<template>
	<div class="chat-box" @click="closeRefBox()" @mousemove="readedMessage()">
		<el-container>
			<el-header height="50px">
				<span>{{ title }}</span>
				<span title="群聊信息" v-show="this.chat.type == 'GROUP'" class="btn-side el-icon-more"
					@click="showSide = !showSide"></span>
				<!-- 多选模式切换按钮 -->
				<span title="多选模式" class="btn-multi-select el-icon-check" 
					:class="{ 'active': multiSelectMode }" @click="toggleMultiSelectMode"></span>
			</el-header>
			<el-main style="padding: 0;">
				<el-container>
					<el-container class="content-box">
						<el-main class="im-chat-main" id="chatScrollBox" @scroll="onScroll">
							<div class="im-chat-box">
								<!-- 历史消息加载指示器 -->
								<div v-if="loadingHistory" class="history-loading-indicator">
									<i class="el-icon-loading"></i>
									<span>正在加载历史消息...</span>
								</div>
								<div v-else-if="noMoreHistory && chat && chat.messages.length > 0" class="no-more-history-indicator">
									<span>没有更多历史消息了</span>
								</div>
								<ul>
									<li v-for="(msgInfo, idx) in chat.messages" :key="idx">
							<chat-message-item v-if="idx >= showMinIdx" @call="onCall(msgInfo.type)"
											:mine="msgInfo.sendId == mine.id" :headImage="headImage(msgInfo)"
											:showName="showName(msgInfo)" :msgInfo="msgInfo"
								:groupMembers="groupMembers" @delete="deleteMessage"
								@recall="recallMessage" @forward="onForwardMessage"
								:multiSelectMode="multiSelectMode" :selectedMessages="selectedMessages"
								@toggle-selection="toggleMessageSelection" @enter-multi-select="enterMultiSelect">
										</chat-message-item>
									</li>
								</ul>
							</div>
						</el-main>
						<el-footer height="220px" class="im-chat-footer">
							<!-- 多选操作栏 -->
							<div v-if="multiSelectMode" class="multi-select-toolbar">
								<div class="select-info">
									<span>已选择 {{ selectedMessages.length }} 条消息</span>
									<el-button size="mini" type="text" @click="selectAllMessages">
										全选 (Ctrl+A)
									</el-button>
									<span class="select-tip">点击消息选择，右键菜单可进入多选模式</span>
								</div>
								<div class="select-actions">
									<el-button size="small" icon="el-icon-position" @click="batchForward">
										转发
									</el-button>
									<el-button size="small" icon="el-icon-delete" type="danger" @click="batchDelete">
										删除
									</el-button>
									<el-button size="small" @click="cancelMultiSelect">
										取消 (Esc)
									</el-button>
								</div>
							</div>
							<!-- 正常工具栏 -->
							<div v-else class="chat-tool-bar">
								<div title="表情" class="icon iconfont icon-emoji" ref="emotion"
									@click.stop="showEmotionBox()">
								</div>
								<div title="发送图片">
									<file-upload :action="'/image/upload'" :maxSize="5 * 1024 * 1024"
										:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
										@before="onImageBefore" @success="onImageSuccess" @fail="onImageFail">
										<i class="el-icon-picture-outline"></i>
									</file-upload>
								</div>
								<div title="发送文件">
									<file-upload ref="fileUpload" :action="'/file/upload'" :maxSize="10 * 1024 * 1024"
										@before="onFileBefore" @success="onFileSuccess" @fail="onFileFail">
										<i class="el-icon-wallet"></i>
									</file-upload>
								</div>
								<div title="回执消息" v-show="chat.type == 'GROUP'" class="icon iconfont icon-receipt"
									:class="isReceipt ? 'chat-tool-active' : ''" @click="onSwitchReceipt">
								</div>
								<div title="发送语音" class="el-icon-microphone" @click="showRecordBox()">
								</div>
								<div title="语音通话" v-show="chat.type == 'PRIVATE'" class="el-icon-phone-outline"
									@click="showPrivateVideo('voice')">
								</div>
								<div title="语音通话" v-show="chat.type == 'GROUP'" class="el-icon-phone-outline"
									@click="onGroupVideo()">
								</div>
								<div title="视频通话" v-show="chat.type == 'PRIVATE'" class="el-icon-video-camera"
									@click="showPrivateVideo('video')">
								</div>
								<div title="聊天记录" class="el-icon-chat-dot-round" @click="showHistoryBox()"></div>
							</div>
							<div class="send-content-area">
								<ChatInput :ownerId="group.ownerId" ref="chatInputEditor" :group-members="groupMembers"
									@submit="sendMessage" :disabled="multiSelectMode" />
								<div class="send-btn-area">
									<el-button type="primary" icon="el-icon-s-promotion"
										@click="notifySend()" :disabled="multiSelectMode">发送</el-button>
								</div>
							</div>
						</el-footer>
					</el-container>
					<el-aside class="chat-group-side-box" width="260px" v-if="showSide">
						<chat-group-side :group="group" :groupMembers="groupMembers" @reload="loadGroup(group.id)">
						</chat-group-side>
					</el-aside>
				</el-container>
			</el-main>
			<emotion ref="emoBox" @emotion="onEmotion"></Emotion>
			<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
			<group-member-selector ref="rtcSel" :groupId="group.id" @complete="onInviteOk"></group-member-selector>
			<rtc-group-join ref="rtcJoin" :groupId="group.id"></rtc-group-join>
			<chat-history :visible="showHistory" :chat="chat" :friend="friend" :group="group"
				:groupMembers="groupMembers" @close="closeHistoryBox"></chat-history>
			<forward-dialog ref="forwardDialog" @confirm="onConfirmForward"></forward-dialog>
		</el-container>
	</div>
</template>

<script>
import ChatGroupSide from "./ChatGroupSide.vue";
import ChatMessageItem from "./ChatMessageItem.vue";
import FileUpload from "../common/FileUpload.vue";
import Emotion from "../common/Emotion.vue";
import ChatRecord from "./ChatRecord.vue";
import ChatHistory from "./ChatHistory.vue";
import ChatAtBox from "./ChatAtBox.vue"
import GroupMemberSelector from "../group/GroupMemberSelector.vue"
import RtcGroupJoin from "../rtc/RtcGroupJoin.vue"
import ChatInput from "./ChatInput";
import ForwardDialog from "./ForwardDialog.vue";


export default {
	name: "chatPrivate",
	components: {
		ChatInput,
		ChatMessageItem,
		FileUpload,
		ChatGroupSide,
		Emotion,
		ChatRecord,
		ChatHistory,
		ChatAtBox,
		GroupMemberSelector,
		RtcGroupJoin,
		ForwardDialog
	},
	props: {
		chat: {
			type: Object
		}
	},
		data() {
		return {
			friend: {},
			group: {},
			groupMembers: [],
			sendImageUrl: "",
			sendImageFile: "",
			placeholder: "",
			isReceipt: true,
			showRecord: false, // 是否显示语音录制弹窗
			showSide: false, // 是否显示群聊信息栏
			showHistory: false, // 是否显示历史聊天记录
			lockMessage: false, // 是否锁定发送，
			showMinIdx: 0, // 下标低于showMinIdx的消息不显示，否则页面会很卡置
			reqQueue: [],
			isSending: false,
			forwardingMsg: null,
			multiSelectMode: false, // 是否开启多选模式
			selectedMessages: [], // 选中的消息列表
			uploadingMessages: new Map(), // 存储上传中的消息信息，key是文件uid
			// 历史消息加载相关
			loadingHistory: false, // 是否正在加载历史消息
			historyPage: 1, // 历史消息页码
			noMoreHistory: false, // 是否已经没有更多历史消息
			lastHistoryLoadTime: 0, // 最后一次加载历史消息的时间，防止频繁请求
			historyCacheKey: '', // 当前聊天的历史消息缓存键
			// 草稿相关
			currentDraft: '' // 当前草稿内容
		}
	},
	methods: {
		closeRefBox() {
			this.$refs.emoBox.close();
			// this.$refs.atBox.close();
		},
		onCall(type) {
			if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VOICE) {
				this.showPrivateVideo('voice');
			} else if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO) {
				this.showPrivateVideo('video');
			}
		},
		onSwitchReceipt() {
			this.isReceipt = !this.isReceipt;
			this.refreshPlaceHolder();
		},
		onImageSuccess(data, originalFile, fileWithMsgInfo) {
			// 优先从组件数据中获取消息信息
			let msgInfo = this.uploadingMessages.get(originalFile.uid);
			
			// 如果组件数据中没有，尝试从file参数中获取（备用方案）
			if (!msgInfo) {
				const file = fileWithMsgInfo || { msgInfo: null };
				if (file.msgInfo) {
					msgInfo = file.msgInfo;
				}
			}
			
			// 检查消息信息是否存在
			if (!msgInfo) {
				console.error('图片上传成功但找不到消息信息，文件uid:', originalFile.uid);
				return;
			}
			
			// 克隆消息信息并更新内容
			let updatedMsgInfo = JSON.parse(JSON.stringify(msgInfo));
			updatedMsgInfo.content = JSON.stringify(data);
			updatedMsgInfo.receipt = this.isReceipt;
			
			this.sendMessageRequest(updatedMsgInfo).then((m) => {
				// 保留原来的 tmpId 确保能找到临时消息
				updatedMsgInfo.loadStatus = 'ok';
				updatedMsgInfo.id = m.id;
				updatedMsgInfo.status = m.status;
				this.isReceipt = false;
				this.$store.commit("insertMessage", [updatedMsgInfo, this.chat]);
				
				// 清理存储的消息信息
				this.uploadingMessages.delete(originalFile.uid);
			})
		},
		onImageFail(e, originalFile, fileWithMsgInfo) {
			// 优先从组件数据中获取消息信息
			let msgInfo = this.uploadingMessages.get(originalFile.uid);
			
			// 如果组件数据中没有，尝试从file参数中获取（备用方案）
			if (!msgInfo) {
				const file = fileWithMsgInfo || { msgInfo: null };
				if (file.msgInfo) {
					msgInfo = file.msgInfo;
				}
			}
			
			// 检查消息信息是否存在
			if (!msgInfo) {
				console.error('图片上传失败但找不到消息信息，文件uid:', originalFile.uid);
				return;
			}
			
			let updatedMsgInfo = JSON.parse(JSON.stringify(msgInfo));
			updatedMsgInfo.loadStatus = 'fail';
			this.$store.commit("insertMessage", [updatedMsgInfo, this.chat]);
			
			// 清理存储的消息信息
			this.uploadingMessages.delete(originalFile.uid);
		},
		onImageBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			let data = {
				originUrl: url,
				thumbUrl: url
			}
			let msgInfo = {
				id: 0,
				tmpId: this.generateId(),
				fileId: file.uid,
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: 1,
				readedCount: 0,
				loadStatus: "loading",
				status: this.$enums.MESSAGE_STATUS.UNSEND
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
			// 会话置顶
			this.moveChatToTop();
			// 滚动到底部
			this.scrollToBottom();
			// 保存消息信息到组件数据中（使用文件uid作为key）
			this.uploadingMessages.set(file.uid, msgInfo);
			// 借助file对象保存（作为备用）
			file.msgInfo = msgInfo;
		},
		onFileSuccess(url, originalFile, fileWithMsgInfo) {
			// 优先从组件数据中获取消息信息
			let msgInfo = this.uploadingMessages.get(originalFile.uid);
			
			// 如果组件数据中没有，尝试从file参数中获取（备用方案）
			if (!msgInfo) {
				const file = fileWithMsgInfo || { msgInfo: null };
				if (file.msgInfo) {
					msgInfo = file.msgInfo;
				}
			}
			
			// 检查消息信息是否存在
			if (!msgInfo) {
				console.error('文件上传成功但找不到消息信息，文件uid:', originalFile.uid);
				return;
			}
			
			let data = {
				name: originalFile.name,
				size: originalFile.size,
				url: url
			}
			let updatedMsgInfo = JSON.parse(JSON.stringify(msgInfo));
			updatedMsgInfo.content = JSON.stringify(data);
			updatedMsgInfo.receipt = this.isReceipt
			
			this.sendMessageRequest(updatedMsgInfo).then((m) => {
				// 保留原来的 tmpId 确保能找到临时消息
				updatedMsgInfo.loadStatus = 'ok';
				updatedMsgInfo.id = m.id;
				updatedMsgInfo.status = m.status;
				this.isReceipt = false;
				this.refreshPlaceHolder();
				this.$store.commit("insertMessage", [updatedMsgInfo, this.chat]);
				
				// 清理存储的消息信息
				this.uploadingMessages.delete(originalFile.uid);
			})
		},
		onFileFail(e, originalFile, fileWithMsgInfo) {
			// 优先从组件数据中获取消息信息
			let msgInfo = this.uploadingMessages.get(originalFile.uid);
			
			// 如果组件数据中没有，尝试从file参数中获取（备用方案）
			if (!msgInfo) {
				const file = fileWithMsgInfo || { msgInfo: null };
				if (file.msgInfo) {
					msgInfo = file.msgInfo;
				}
			}
			
			// 检查消息信息是否存在
			if (!msgInfo) {
				console.error('文件上传失败但找不到消息信息，文件uid:', originalFile.uid);
				return;
			}
			
			let updatedMsgInfo = JSON.parse(JSON.stringify(msgInfo));
			updatedMsgInfo.loadStatus = 'fail';
			this.$store.commit("insertMessage", [updatedMsgInfo, this.chat]);
			
			// 清理存储的消息信息
			this.uploadingMessages.delete(originalFile.uid);
		},
		onFileBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = {
				id: 0,
				tmpId: this.generateId(),
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: 2,
				loadStatus: "loading",
				readedCount: 0,
				status: this.$enums.MESSAGE_STATUS.UNSEND
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
			// 会话置顶
			this.moveChatToTop();
			// 滚动到底部
			this.scrollToBottom();
			// 保存消息信息到组件数据中（使用文件uid作为key）
			this.uploadingMessages.set(file.uid, msgInfo);
			// 借助file对象透传（作为备用）
			file.msgInfo = msgInfo;
		},
		onCloseSide() {
			this.showSide = false;
		},
		onScrollToTop() {
			// 多展示10条信息
			this.showMinIdx = this.showMinIdx > 10 ? this.showMinIdx - 10 : 0;
		},
		onScroll(e) {
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop
			if (scrollTop < 30) { // 在顶部,不滚动的情况
				// 多展示20条信息
				this.showMinIdx = this.showMinIdx > 20 ? this.showMinIdx - 20 : 0;
				// 加载历史消息
				this.loadMoreHistory();
			}
		},
		showEmotionBox() {
			let width = this.$refs.emotion.offsetWidth;
			let left = this.$elm.fixLeft(this.$refs.emotion);
			let top = this.$elm.fixTop(this.$refs.emotion);
			this.$refs.emoBox.open({
				x: left + width / 2,
				y: top
			})
		},
		onEmotion(emoText) {
			this.$refs.chatInputEditor.insertEmoji(emoText);
		},
		showRecordBox() {
			this.showRecord = true;
		},
		closeRecordBox() {
			this.showRecord = false;
		},
		showPrivateVideo(mode) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}

			let rtcInfo = {
				mode: mode,
				isHost: true,
				friend: this.friend,
			}
			// 通过home.vue打开单人视频窗口
			this.$eventBus.$emit("openPrivateVideo", rtcInfo);
		},
		onGroupVideo() {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			// 邀请成员发起通话
			let ids = [this.mine.id];
			let maxChannel = this.$store.state.configStore.webrtc.maxChannel;
			this.$refs.rtcSel.open(maxChannel, ids, ids);
		},
		onInviteOk(members) {
			if (members.length < 2) {
				return;
			}
			let userInfos = [];
			members.forEach(m => {
				userInfos.push({
					id: m.userId,
					nickName: m.showNickName,
					headImage: m.headImage,
					isCamera: false,
					isMicroPhone: true
				})
			})
			let rtcInfo = {
				isHost: true,
				groupId: this.group.id,
				inviterId: this.mine.id,
				userInfos: userInfos
			}
			// 通过home.vue打开多人视频窗口
			this.$eventBus.$emit("openGroupVideo", rtcInfo);
		},
		showHistoryBox() {
			this.showHistory = true;
		},
		closeHistoryBox() {
			this.showHistory = false;
		},
		// 加载更多历史消息
		async loadMoreHistory() {
			// 检查是否正在加载或没有更多历史消息
			if (this.loadingHistory || this.noMoreHistory) {
				return;
			}
			
			// 防止频繁请求，至少间隔500ms
			const now = Date.now();
			if (now - this.lastHistoryLoadTime < 500) {
				return;
			}
			
			// 检查是否有聊天对象
			if (!this.chat || !this.chat.targetId) {
				return;
			}
			
			this.lastHistoryLoadTime = now;
			this.loadingHistory = true;
			
			try {
				// 准备请求参数
				const params = {
					page: this.historyPage,
					size: 20 // 每次加载20条历史消息
				};
				
				// 根据聊天类型设置参数
				if (this.chat.type === 'GROUP') {
					params.groupId = this.chat.targetId;
				} else {
					params.friendId = this.chat.targetId;
				}
				
				console.log('开始加载历史消息:', params);
				
				// 请求历史消息
				const messages = await this.$http({
					url: `/message/${this.chat.type.toLowerCase()}/history`,
					method: 'get',
					params: params
				});
				
				// 如果没有更多消息
				if (!messages || messages.length === 0) {
					this.noMoreHistory = true;
					// 保存"没有更多历史消息"的状态
					this.saveHistoryState();
					return;
				}
				
				console.log('加载到历史消息:', messages.length, '条');
				
				// 将历史消息插入到当前消息列表前面
				this.prependMessages(messages);
				
				// 增加页码
				this.historyPage++;
				
				// 保存当前历史消息加载状态
				this.saveHistoryState();
				
				// 调整showMinIdx，确保新消息被显示
				this.showMinIdx = Math.max(0, this.showMinIdx - messages.length);
				
				console.log('历史消息加载完成，新显示索引:', this.showMinIdx);
				
				// 检查是否还需要继续加载历史消息
				this.checkAutoLoadHistory();
				
			} catch (error) {
				console.error('加载历史消息失败:', error);
				this.$message.error('加载历史消息失败');
			} finally {
				this.loadingHistory = false;
			}
		},
		// 将历史消息插入到当前消息列表前面
		prependMessages(messages) {
			if (!this.chat || !this.chat.messages) {
				return;
			}
			
			// 使用store的prependMessages方法
			this.$store.commit("prependMessages", [messages, this.chat]);
		},
		// 保存历史消息加载状态
		saveHistoryState() {
			if (this.historyCacheKey) {
				const state = {
					historyPage: this.historyPage,
					noMoreHistory: this.noMoreHistory,
					timestamp: Date.now()
				};
				localStorage.setItem(this.historyCacheKey, JSON.stringify(state));
			}
		},
		// 重置历史消息加载状态
		resetHistoryState() {
			this.loadingHistory = false;
			
			// 生成当前聊天的历史消息缓存键
			this.historyCacheKey = `history-${this.chat.type}-${this.chat.targetId}`;
			
			// 从缓存中获取历史消息加载状态
			const cacheState = localStorage.getItem(this.historyCacheKey);
			const localMessageCount = this.chat && this.chat.messages ? this.chat.messages.length : 0;
			
			if (cacheState && localMessageCount > 20) {
				// 存在缓存状态且本地消息充足，恢复缓存状态
				const state = JSON.parse(cacheState);
				this.historyPage = state.historyPage || Math.ceil(localMessageCount / 20) + 1;
				this.noMoreHistory = state.noMoreHistory || false;
				console.log(`恢复历史消息缓存状态: page=${this.historyPage}, noMore=${this.noMoreHistory}, localCount=${localMessageCount}`);
			} else if (localMessageCount > 50) {
				// 本地消息较多但无缓存状态，从合理页码开始
				this.historyPage = Math.ceil(localMessageCount / 20) + 1;
				this.noMoreHistory = false;
				console.log(`检测到本地已有${localMessageCount}条消息，从第${this.historyPage}页开始请求`);
			} else {
				// 本地消息较少，从第1页开始
				this.historyPage = 1;
				this.noMoreHistory = false;
			}
			
			this.lastHistoryLoadTime = 0;
		},
		onSendRecord(data) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let msgInfo = {
				content: JSON.stringify(data),
				type: 3,
				receipt: this.isReceipt
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			this.sendMessageRequest(msgInfo).then((m) => {
				m.selfSend = true;
				this.$store.commit("insertMessage", [m, this.chat]);
				// 会话置顶
				this.moveChatToTop();
				// 保持输入框焦点
				this.$refs.chatInputEditor.focus();
				// 滚动到底部
				this.scrollToBottom();
				// 关闭录音窗口
				this.showRecord = false;
				this.isReceipt = false;
				this.refreshPlaceHolder();
			})
		},
		fillTargetId(msgInfo, targetId) {
			if (this.chat.type == "GROUP") {
				msgInfo.groupId = targetId;
			} else {
				msgInfo.recvId = targetId;
			}
		},
		notifySend() {
			this.$refs.chatInputEditor.submit();
		},
		async sendMessage(fullList) {
			// 发送消息时清除草稿
			this.clearDraft();
			this.resetEditor();
			this.readedMessage();
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let sendText = this.isReceipt ? "【回执消息】" : "";
			let promiseList = [];
			for (let i = 0; i < fullList.length; i++) {
				let msg = fullList[i];
				switch (msg.type) {
					case "text":
						await this.sendTextMessage(sendText + msg.content, msg.atUserIds);
						break;
					case "image":
						await this.sendImageMessage(msg.content.file);
						break;
					case "file":
						await this.sendFileMessage(msg.content.file);
						break;
				}

			}
		},
		sendImageMessage(file) {
			return new Promise((resolve, reject) => {
				this.onImageBefore(file);
				let formData = new FormData()
				formData.append('file', file)
				this.$http.post("/image/upload", formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then((data) => {
					this.onImageSuccess(data, file);
					resolve();
				}).catch((res) => {
					this.onImageFail(res, file);
					reject();
				})
				this.$nextTick(() => this.$refs.chatInputEditor.focus());
				this.scrollToBottom();
			});
		},
		sendTextMessage(sendText, atUserIds) {
			return new Promise((resolve, reject) => {
				if (!sendText.trim()) {
					reject();
				}
				let msgInfo = {
					content: sendText,
					type: 0
				}
				// 填充对方id
				this.fillTargetId(msgInfo, this.chat.targetId);
				// 被@人员列表
				if (this.chat.type == "GROUP") {
					msgInfo.atUserIds = atUserIds;
					msgInfo.receipt = this.isReceipt;
				}
				this.lockMessage = true;
				this.sendMessageRequest(msgInfo).then((m) => {
					m.selfSend = true;
					this.$store.commit("insertMessage", [m, this.chat]);
					// 会话置顶
					this.moveChatToTop();
				}).finally(() => {
					// 解除锁定
					this.scrollToBottom();
					this.isReceipt = false;
					resolve();
				});
			});
		},
		sendFileMessage(file) {
			return new Promise((resolve, reject) => {
				let check = this.$refs.fileUpload.beforeUpload(file);
				if (check) {
					this.$refs.fileUpload.onFileUpload({ file });
				}
			})
		},
		deleteMessage(msgInfo) {
			this.$confirm('确认删除消息?', '删除消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$store.commit("deleteMessage", [msgInfo, this.chat]);
			});
		},
		onForwardMessage(msgInfo) {
			this.forwardingMsg = msgInfo;
			this.$refs.forwardDialog.open();
		},
		onConfirmForward(target) {
			if (!this.forwardingMsg) {
				return;
			}
			
			// 处理批量转发
			const messages = Array.isArray(this.forwardingMsg) ? this.forwardingMsg : [this.forwardingMsg];
			const isBatchForward = Array.isArray(this.forwardingMsg);
			
			messages.forEach(src => {
				const msg = {
					type: src.type,
					content: src.content
				};
				if (target.type === 'GROUP') {
					msg.groupId = target.targetId;
				} else {
					msg.recvId = target.targetId;
				}
				const url = `/message/${target.type.toLowerCase()}/send`;
				this.$http({ url, method: 'post', data: msg }).then((m) => {
					m.selfSend = true;
					const chatInfo = { type: target.type, targetId: target.targetId };
					this.$store.commit('openChat', { ...chatInfo, showName: target.showName, headImage: '' });
					this.$store.commit('insertMessage', [m, chatInfo]);
				});
			});
			
			this.$message.success(`已转发 ${messages.length} 条消息`);
			this.forwardingMsg = null;
			
			// 如果是批量转发，退出多选模式
			if (isBatchForward) {
				this.selectedMessages = [];
				this.multiSelectMode = false;
			}
		},
		recallMessage(msgInfo) {
			this.$confirm('确认撤回消息?', '撤回消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let url = `/message/${this.chat.type.toLowerCase()}/recall/${msgInfo.id}`
				this.$http({
					url: url,
					method: 'delete'
				}).then(() => {
					this.$message.success("消息已撤回");
					msgInfo = JSON.parse(JSON.stringify(msgInfo));
					msgInfo.type = 10;
					msgInfo.content = '你撤回了一条消息';
					msgInfo.status = this.$enums.MESSAGE_STATUS.RECALL;
					this.$store.commit("insertMessage", [msgInfo, this.chat]);
				})
			});
		},
		readedMessage() {
			if (this.chat.unreadCount == 0) {
				return;
			}
			this.$store.commit("resetUnreadCount", this.chat)
			if (this.chat.type == "GROUP") {
				var url = `/message/group/readed?groupId=${this.chat.targetId}`
			} else {
				url = `/message/private/readed?friendId=${this.chat.targetId}`
			}
			this.$http({
				url: url,
				method: 'put'
			}).then(() => {})
		},
		loadReaded(fId) {
			this.$http({
				url: `/message/private/maxReadedId?friendId=${fId}`,
				method: 'get'
			}).then((id) => {
				this.$store.commit("readedMessage", {
					friendId: fId,
					maxId: id
				});
			});
		},
		loadGroup(groupId) {
			this.$http({
				url: `/group/find/${groupId}`,
				method: 'get'
			}).then((group) => {
				this.group = group;
				this.$store.commit("updateChatFromGroup", group);
				this.$store.commit("updateGroup", group);
			});

			this.$http({
				url: `/group/members/${groupId}`,
				method: 'get'
			}).then((groupMembers) => {
				this.groupMembers = groupMembers;
			});
		},
		loadFriend(friendId) {
			// 先从好友列表中获取好友信息（包含备注名称）
			let friendInfo = this.$store.getters.findFriend(friendId);
			if (friendInfo) {
				this.friend = friendInfo;
				// 使用好友信息更新聊天标题（包含备注名称）
				this.$store.commit("updateChatFromFriend", friendInfo);
			} else {
				// 如果好友列表中没有，则获取用户信息
				this.$http({
					url: `/user/find/${friendId}`,
					method: 'get'
				}).then((friend) => {
					this.friend = friend;
					this.$store.commit("updateChatFromFriend", friend);
					this.$store.commit("updateFriend", friend);
				})
			}
		},
		showName(msgInfo) {
			if (this.chat.type == 'GROUP') {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.showNickName : "";
			} else {
				return msgInfo.sendId == this.mine.id ? this.mine.nickName : this.chat.showName
			}

		},
		headImage(msgInfo) {
			if (this.chat.type == 'GROUP') {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? (member.headImage || "") : "";
			} else {
				return msgInfo.sendId == this.mine.id ? (this.mine.headImageThumb || "") : (this.chat.headImage || "")
			}
		},
		resetEditor() {

			this.$nextTick(() => {
				this.$refs.chatInputEditor.clear();
				this.$refs.chatInputEditor.focus();
			});
		},
		scrollToBottom() {
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				div.scrollTop = div.scrollHeight;
			});
		},
		refreshPlaceHolder() {
			if (this.isReceipt) {
				this.placeholder = "【回执消息】"
			} else if (this.$refs.editBox && this.$refs.editBox.innerHTML) {
				this.placeholder = ""
			} else {
				this.placeholder = "聊点什么吧~";
			}
		},
		sendMessageRequest(msgInfo) {
			return new Promise((resolve, reject) => {
				// 请求入队列，防止请求"后发先至"，导致消息错序
				this.reqQueue.push({ msgInfo, resolve, reject });
				this.processReqQueue();
			})
		},
		processReqQueue() {
			if (this.reqQueue.length && !this.isSending) {
				this.isSending = true;
				const reqData = this.reqQueue.shift();
				this.$http({
					url: this.messageAction,
					method: 'post',
					data: reqData.msgInfo
				}).then((res) => {
					reqData.resolve(res)
				}).catch((e) => {
					reqData.reject(e)
				}).finally(() => {
					this.isSending = false;
					// 发送下一条请求
					this.processReqQueue();
				})
			}
		},
		showBannedTip() {
			let msgInfo = {
				tmpId: this.generateId(),
				sendId: this.mine.id,
				sendTime: new Date().getTime(),
				type: this.$enums.MESSAGE_TYPE.TIP_TEXT
			}
			if (this.chat.type == "PRIVATE") {
				msgInfo.recvId = this.chat.targetId
				msgInfo.content = "该用户已被管理员封禁,原因:" + this.friend.reason
			} else {
				msgInfo.groupId = this.group.id;
				msgInfo.content = "本群聊已被管理员封禁,原因:" + this.group.reason
			}
			this.$store.commit("insertMessage", [msgInfo, this.chat]);
		},
		generateId() {
			// 生成临时id
			return String(new Date().getTime()) + String(Math.floor(Math.random() * 1000));
		},
		toggleMultiSelectMode() {
			this.multiSelectMode = !this.multiSelectMode;
			this.selectedMessages = [];
		},
		toggleMessageSelection(msgInfo) {
			const index = this.selectedMessages.findIndex(item => item.id === msgInfo.id);
			if (index === -1) {
				this.selectedMessages.push(msgInfo);
			} else {
				this.selectedMessages.splice(index, 1);
			}
		},
		batchForward() {
			if (this.selectedMessages.length === 0) {
				this.$message.warning('请选择要转发的消息');
				return;
			}
			this.forwardingMsg = this.selectedMessages;
			this.$refs.forwardDialog.open();
		},
		batchDelete() {
			if (this.selectedMessages.length === 0) {
				this.$message.warning('请选择要删除的消息');
				return;
			}
			this.$confirm(`确认删除选中的 ${this.selectedMessages.length} 条消息?`, '删除消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const count = this.selectedMessages.length;
				// 直接调用store的deleteMessage，不弹出确认框
				this.selectedMessages.forEach(msg => {
					this.$store.commit("deleteMessage", [msg, this.chat]);
				});
				this.selectedMessages = [];
				this.multiSelectMode = false;
				this.$message.success(`已删除 ${count} 条消息`);
			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		cancelMultiSelect() {
			this.multiSelectMode = false;
			this.selectedMessages = [];
		},
		enterMultiSelect(msgInfo) {
			this.multiSelectMode = true;
			this.selectedMessages = [msgInfo];
		},
		// 键盘事件处理
		handleKeydown(e) {
			if (this.multiSelectMode) {
				// Ctrl+A 全选
				if (e.ctrlKey && e.key === 'a') {
					e.preventDefault();
					this.selectAllMessages();
				}
				// Esc 退出多选模式
				if (e.key === 'Escape') {
					this.cancelMultiSelect();
				}
			}
		},
		// 全选消息
		selectAllMessages() {
			this.selectedMessages = this.chat.messages.filter(msg => 
				msg.type !== this.$enums.MESSAGE_TYPE.TIP_TIME && 
				msg.type !== this.$enums.MESSAGE_TYPE.TIP_TEXT &&
				msg.type !== this.$enums.MESSAGE_TYPE.RECALL
			);
		},
		// 检查是否需要自动加载历史消息（当内容不足时）
		checkAutoLoadHistory() {
			this.$nextTick(() => {
				const chatScrollBox = document.getElementById("chatScrollBox");
				if (!chatScrollBox) {
					return;
				}
				
				// 检查是否有滚动条：scrollHeight > clientHeight 表示有滚动条
				const hasScrollbar = chatScrollBox.scrollHeight > chatScrollBox.clientHeight;
				
				// 如果没有滚动条且还有历史消息可以加载，则自动加载
				if (!hasScrollbar && !this.noMoreHistory && !this.loadingHistory && this.chat && this.chat.targetId) {
					console.log('内容不足以产生滚动条，自动加载历史消息');
					this.loadMoreHistory();
				}
			});
		},
		// 将当前聊天置顶（重新排序聊天列表）
		moveChatToTop() {
			this.$store.commit("sortChats");
		},
		// 获取当前聊天的ID
		getChatId() {
			return `${this.chat.type}-${this.chat.targetId}`;
		},
		// 检查是否有未发送内容
		hasUnsavedContent() {
			if (this.$refs.chatInputEditor) {
				const content = this.$refs.chatInputEditor.getContent();
				if (!content) return false;
				
				const trimmedContent = content.trim();
				// 检查各种空内容情况
				const emptyPatterns = [
					'',
					'<div>&nbsp;</div>',
					'<br>',
					'<div><br></div>',
					'<p><br></p>',
					'<div></div>',
					'<p></p>',
					'&nbsp;'
				];
				
				return !emptyPatterns.includes(trimmedContent) && 
					   trimmedContent.replace(/(<[^>]*>)|(&nbsp;)|\s/g, '').length > 0;
			}
			return false;
		},
		// 保存草稿（仅在切换聊天时调用）
		saveDraft() {
			if (this.$refs.chatInputEditor && this.chat) {
				if (this.hasUnsavedContent()) {
					// 有内容时保存草稿
					const content = this.$refs.chatInputEditor.getContent();
					this.currentDraft = content;
					this.$store.commit("saveDraft", {
						chatId: this.getChatId(),
						content: content
					});
					console.log('草稿已保存:', this.getChatId(), content.slice(0, 50));
				} else {
					// 没有内容时清除草稿
					this.clearDraft();
				}
				// 强制触发Vue更新以确保ChatItem重新计算
				this.$nextTick(() => {
					this.$forceUpdate();
					// 通知所有ChatItem更新
					this.$eventBus.$emit('draftStateChanged');
				});
				// 重新排序聊天列表
				this.$store.commit("sortChats");
			}
		},
		// 清除草稿
		clearDraft() {
			this.currentDraft = '';
			this.$store.commit("clearDraft", this.getChatId());
			console.log('草稿已清除:', this.getChatId());
			// 强制触发Vue更新以确保ChatItem重新计算
			this.$nextTick(() => {
				this.$forceUpdate();
				// 通知所有ChatItem更新
				this.$eventBus.$emit('draftStateChanged');
			});
			// 重新排序聊天列表
			this.$store.commit("sortChats");
		},
		// 加载草稿
		loadDraft() {
			const chatId = this.getChatId();
			const draft = this.$store.state.chatStore.drafts[chatId];
			if (draft && this.$refs.chatInputEditor) {
				this.$refs.chatInputEditor.setContent(draft);
				this.currentDraft = draft;
			}
		},
		// 检查并保存草稿（响应事件总线调用）
		checkAndSaveDraft() {
			// 确保组件已挂载且有引用
			if (this.$refs.chatInputEditor && this.chat) {
				this.saveDraft();
			}
		}
	},
	computed: {
		mine() {
			return this.$store.state.userStore.userInfo;
		},
		title() {
			let title = this.chat.showName;
			if (this.chat.type == "GROUP") {
				let size = this.groupMembers.filter(m => !m.quit).length;
				title += `(${size})`;
			}
			return title;
		},
		messageAction() {
			return `/message/${this.chat.type.toLowerCase()}/send`;
		},
		unreadCount() {
			return this.chat.unreadCount;
		},
		messageSize() {
			if (!this.chat || !this.chat.messages) {
				return 0;
			}
			return this.chat.messages.length;
		},
		isBanned() {
			return (this.chat.type == "PRIVATE" && this.friend.isBanned) ||
				(this.chat.type == "GROUP" && this.group.isBanned)
		}
	},
	watch: {
		chat: {
			handler(newChat, oldChat) {
				if (newChat.targetId > 0 && (!oldChat || newChat.type != oldChat.type ||
						newChat.targetId != oldChat.targetId)) {
					if (this.chat.type == "GROUP") {
						this.loadGroup(this.chat.targetId);
					} else {
						this.loadFriend(this.chat.targetId);
						// 加载已读状态
						this.loadReaded(this.chat.targetId)
					}
					this.showSide = false;
					// 消息已读
					this.readedMessage()
					// 初始状态只显示30条消息
					let size = this.chat.messages.length;
					this.showMinIdx = size > 30 ? size - 30 : 0;
					// 重置输入框
					this.resetEditor();
					// 加载新聊天的草稿
					this.$nextTick(() => {
						this.loadDraft();
					});
					// 复位回执消息
					this.isReceipt = false;
					// 更新placeholder
					this.refreshPlaceHolder();
					// 重置历史消息加载状态
					this.resetHistoryState();
					// 确保在DOM更新后滚动到底部显示最新消息
					this.$nextTick(() => {
						this.scrollToBottom();
						// 检查是否需要自动加载历史消息
						this.checkAutoLoadHistory();
					});
				}
			},
			immediate: true
		},
		messageSize: {
			handler(newSize, oldSize) {
				if (newSize > oldSize) {
					// 新消息到达时，确保在DOM更新后拉至底部
					this.$nextTick(() => {
						this.scrollToBottom();
					});
				}
			}
		}
	},
	mounted() {
		let div = document.getElementById("chatScrollBox");
		div.addEventListener('scroll', this.onScroll);
		// 确保聊天界面打开时自动滚动到底部显示最新消息
		this.$nextTick(() => {
			this.scrollToBottom();
			// 检查是否需要自动加载历史消息
			this.checkAutoLoadHistory();
		});
		
		// 添加键盘事件监听
		document.addEventListener('keydown', this.handleKeydown);
		
		// 监听草稿检查事件
		this.$eventBus.$on('checkDraft', this.checkAndSaveDraft);
	},
	beforeDestroy() {
		// 移除键盘事件监听
		document.removeEventListener('keydown', this.handleKeydown);
		// 移除事件监听
		this.$eventBus.$off('checkDraft', this.checkAndSaveDraft);
		// 保存当前草稿
		this.saveDraft();
	}
}
</script>

<style lang="scss">
.chat-box {
	position: relative;
	width: 100%;
	background: #fff;

	.el-header {
		display: flex;
		justify-content: space-between;
		padding: 0 12px;
		line-height: 50px;
		font-size: var(--im-font-size-larger);
		border-bottom: var(--im-border);

		.btn-side {
			position: absolute;
			right: 20px;
			line-height: 50px;
			font-size: 20px;
			cursor: pointer;
			color: var(--im-text-color-light);
		}

		.btn-multi-select {
			position: absolute;
			right: 50px;
			line-height: 50px;
			font-size: 20px;
			cursor: pointer;
			color: var(--im-text-color-light);
			transition: color 0.3s;

			&:hover {
				color: var(--im-color-primary);
			}

			&.active {
				color: var(--im-color-primary);
			}
		}
	}

	.im-chat-main {
		padding: 0;
		background-color: #fff;

		.im-chat-box {
			>ul {
				padding: 0 20px;

				li {
					list-style-type: none;
				}
			}
		}
	}

	.im-chat-footer {
		display: flex;
		flex-direction: column;
		padding: 0;

		.multi-select-toolbar {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 8px 12px;
			background-color: #f5f7fa;
			border-top: var(--im-border);
			border-bottom: var(--im-border);

			.select-info {
				display: flex;
				align-items: center;
				gap: 12px;
				font-size: 14px;
				color: #606266;

				.el-button {
					padding: 2px 8px;
					font-size: 12px;
				}

				.select-tip {
					font-size: 12px;
					color: #909399;
					font-style: italic;
				}
			}

			.select-actions {
				display: flex;
				align-items: center;
				gap: 8px;

				.el-button {
					margin-left: 0;
				}
			}
		}

		.chat-tool-bar {
			display: flex;
			position: relative;
			width: 100%;
			height: 36px;
			text-align: left;
			box-sizing: border-box;
			border-top: var(--im-border);
			padding: 4px 2px 2px 8px;

			>div {
				font-size: 22px;
				cursor: pointer;
				line-height: 30px;
				width: 30px;
				height: 30px;
				text-align: center;
				border-radius: 2px;
				margin-right: 8px;
				color: #999;
				transition: 0.3s;

				&.chat-tool-active {
					font-weight: 600;
					color: var(--im-color-primary);
					background-color: #ddd;
				}
			}

			>div:hover {
				color: #333;
			}
		}

		.send-content-area {
			position: relative;
			display: flex;
			flex-direction: column;
			height: 100%;
			background-color: white !important;

			.send-text-area {
				box-sizing: border-box;
				padding: 5px;
				width: 100%;
				flex: 1;
				resize: none;
				font-size: 16px;
				outline: none;

				text-align: left;
				line-height: 30px;

				&:before {
					content: attr(placeholder);
					color: gray;
				}

				.at {
					color: blue;
					font-weight: 600;
				}

				.receipt {
					color: darkblue;
					font-size: 15px;
					font-weight: 600;
				}

				.emo {
					width: 30px;
					height: 30px;
					vertical-align: bottom;
				}
			}

			.send-image-area {
				text-align: left;
				border: #53a0e7 solid 1px;

				.send-image-box {
					position: relative;
					display: inline-block;

					.send-image {
						max-height: 180px;
						border: 1px solid #ccc;
						border-radius: 2%;
						margin: 2px;
					}

					.send-image-close {
						position: absolute;
						padding: 3px;
						right: 7px;
						top: 7px;
						color: white;
						cursor: pointer;
						font-size: 15px;
						font-weight: 600;
						background-color: #aaa;
						border-radius: 50%;
						border: 1px solid #ccc;
					}
				}
			}

			.send-btn-area {
				padding: 10px;
				position: absolute;
				bottom: 4px;
				right: 6px;
			}
		}
	}

	.chat-group-side-box {
		border-left: var(--im-border);
		//animation: rtl-drawer-in .3s 1ms;
	}

	// 历史消息加载指示器样式
	.history-loading-indicator {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px;
		color: var(--im-text-color-light);
		font-size: 14px;
		background-color: #f9f9f9;
		border-bottom: 1px solid #eee;

		i {
			margin-right: 8px;
			font-size: 16px;
		}
	}

	.no-more-history-indicator {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px;
		color: var(--im-text-color-light);
		font-size: 14px;
		background-color: #f9f9f9;
		border-bottom: 1px solid #eee;
	}

}
</style>